// Utilidad para normalizar y formatear RUT chileno.
// Entradas aceptan con o sin puntos/guión, mayúsculas o minúsculas.
//
// FORMATO ESTÁNDAR DE PANTALLA: sin puntos, con guión y DV en mayúscula → 12345678-9
// Es el mismo formato en que el backend almacena y busca el RUT, así que lo que se ve en
// pantalla se puede copiar y pegar directamente en cualquier buscador. Nunca mostrar
// separadores de miles (12.345.678-9).
//
// Si no es posible validar mínimamente la estructura, retorna la entrada original.

/**
 * Normaliza un RUT eliminando puntos y guión y pasando a minúsculas
 * @param value RUT de entrada (ej: 12.345.678-9)
 * @returns string sin separadores (ej: 123456789)
 */
export function normalizeRut(value: string): string {
  return (value || '').replace(/\./g, '').replace(/-/g, '').trim().toLowerCase();
}

/**
 * Aplica el formato estándar de pantalla a un RUT normalizado o crudo: cuerpo-DV, sin
 * separadores de miles y con el dígito verificador en mayúscula.
 * No valida dígito verificador; solo formatea estructura cuando es posible.
 * @param value RUT de entrada (ej: 123456789 o 12.345.678-9)
 * @returns RUT formateado (ej: 12345678-9) o valor original si no se puede formatear.
 */
export function formatRut(value: string): string {
  if (!value) return '';
  const raw = normalizeRut(value);
  if (raw.length < 2) return value; // Debe tener al menos cuerpo + dv

  const cuerpo = raw.slice(0, -1);
  const dv = raw.slice(-1);
  if (!/^\d+$/.test(cuerpo)) return value; // cuerpo debe ser numérico

  return `${cuerpo}-${dv}`.toUpperCase();
}

/**
 * @deprecated Alias histórico de formatRut(), que desde ASIS-5560 ya nunca inserta puntos.
 * Usar formatRut() en código nuevo.
 */
export const formatRutWithoutDots = formatRut;

export default formatRut;
